import { render, staticRenderFns } from "./LiveItem.vue?vue&type=template&id=ee2b05d0&scoped=true&"
import script from "./LiveItem.vue?vue&type=script&lang=js&"
export * from "./LiveItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee2b05d0",
  null
  
)

export default component.exports